import { render, staticRenderFns } from "./NoResultsState.vue?vue&type=template&id=4b5b1f5a&scoped=true&"
import script from "./NoResultsState.vue?vue&type=script&lang=ts&"
export * from "./NoResultsState.vue?vue&type=script&lang=ts&"
import style0 from "./NoResultsState.vue?vue&type=style&index=0&id=4b5b1f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b1f5a",
  null
  
)

export default component.exports